// extracted by mini-css-extract-plugin
module.exports = {"base":"style_base__3d1o4","content":"style_content__1XDEv","title":"style_title__2wAYR","icon":"style_icon__1fKBS","margin":"style_margin__2tUEV"};